import { theme } from 'common/theme';
import { BrandColorMapType } from 'common/types/common';
import { FilterNames } from 'common/types/filters';

export const getColorForData = (index: number): string => {
  const colorPalette = theme.v2.chart.colorPalette;
  return colorPalette[index % colorPalette.length];
};

export const addOpacityToColor = (color: string, opacity: number): string => {
  const colorValues = color.match(/\((.*?)\)/); //e.g. (255,225,255)
  return colorValues ? `rgba(${colorValues[1]}, ${opacity})` : color;
};

export const getAverageColor = (): string => {
  return theme.chart.average.toString();
};

export const getItemColor = (
  itemLabel: string,
  currentItemIndex: number,
  secondDimension: string,
  brandsColorMap: BrandColorMapType | null,
  getColorForData: (index: number) => string,
) => {
  if (secondDimension === FilterNames.BRAND && brandsColorMap?.[itemLabel]) {
    return brandsColorMap[itemLabel];
  }

  return getColorForData(currentItemIndex);
};

export const hexToRGBA = (hex: string, opacity: number) => {
  if (!hex) return 'rgba(0, 0, 0, 0)';

  const r = parseInt(hex?.slice(1, 3), 16);
  const g = parseInt(hex?.slice(3, 5), 16);
  const b = parseInt(hex?.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
